/* tslint:disable */
/* eslint-disable */
/**
 * COTATO 프로젝트 API 명세서
 * api 명세서
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CotatoPolicyInfoResponseTypeEnum = {
    Essential: 'ESSENTIAL',
    Optional: 'OPTIONAL'
};
/**
 * Check if a given object implements the CotatoPolicyInfoResponse interface.
 */
export function instanceOfCotatoPolicyInfoResponse(value) {
    return true;
}
export function CotatoPolicyInfoResponseFromJSON(json) {
    return CotatoPolicyInfoResponseFromJSONTyped(json, false);
}
export function CotatoPolicyInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'policyId': json['policyId'] == null ? undefined : json['policyId'],
        'type': json['type'] == null ? undefined : json['type'],
        'title': json['title'] == null ? undefined : json['title'],
        'content': json['content'] == null ? undefined : json['content'],
    };
}
export function CotatoPolicyInfoResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'policyId': value['policyId'],
        'type': value['type'],
        'title': value['title'],
        'content': value['content'],
    };
}
